import gql from 'graphql-tag'

export const CORRESPONDENCE_SALUTATION_UPDATE_MUTATION = gql`
    mutation correspondenceSalutationUpdate(
        $id: ID!
        $salutation: EditorContentInput!
    ) {
        correspondenceSalutationUpdate(
            id: $id
            salutation: $salutation
        ) {
            id
            contact_type
            formality
            gender
            language {
                id
                name
            }
            is_default
            salutation {
                schemaType
                schemaVersion
                contentJSON
                contentHTML
                attrs
            }
            created_at
            updated_at
        }
    }
`
